import { has } from 'lodash';

export const CREATE_JOB = 'CREATE_JOB';
export const CREATE_JOBS = 'CREATE_JOBS';
export const CREATE_FAST_TRACK = 'CREATE_FAST_TRACK';

const Stash = (name: string) => {
  const storage = () => {
    const data = localStorage.getItem(name);
    if (data === null || data === '') return {};
    return JSON.parse(data);
  };

  const clean = () => {
    localStorage.removeItem(name);
  };

  const load = (key: string) => {
    const items = storage();
    if (!has(items, key)) return {};
    return items[key];
  };

  const save = (key: string, values: object) => {
    const items = storage();
    localStorage.setItem(name, JSON.stringify({ ...items, [key]: values }));
  };

  const remove = (key: string) => {
    const items = storage();
    delete items[key];
    localStorage.setItem(name, JSON.stringify(items));
  };

  return {
    load,
    save,
    remove,
    clean,
  };
};

export default Stash;
